'use strict';

window.$ = global.jQuery = require("jquery");
require('./vendor/jquery.accordion.js');
require('./vendor/jquery-ui.min.js');
require('jquery-placeholder');

function browserDetection() {
    var ua = window.navigator.userAgent;
    var version = null;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        version = ua.substring(msie + 5, ua.indexOf('.', msie));
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        var rv = ua.indexOf('rv:');
        if (rv > 0) {
            version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        version = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    var $html = jQuery('html');
    if (version) {
        $html.addClass('ie' + version);
        $html.addClass('ie');
    }
}
browserDetection();

$(document).ready(function () {

    /* Homepage */
    $('.scrollto').click(function() {
        var target = $(this).data('target');
        var scrollTop = 0;
        if (target != 'top') {
            scrollTop = $(target).offset().top;
        }
        $('html, body').animate({
                scrollTop: scrollTop
            }, 1000, 'easeOutExpo');
    });

    $('input, textarea').placeholder();

    $('.accordion').accordion({
        singleOpen: false
    });

    // check if there is an accordion element correspoding to the anchor and open it
    let hash = window.location.hash.substring(1);
    if (hash != "") {
        $("#" + hash + "[data-control]").trigger('click');
    }
    // Sticky header / TODO move to shared

    // Hide Header only on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var $header = $('.site-header');
    var navbarHeight = $header.outerHeight();
    var $headerTop = $('.header-top');
    var topBarHeight = 0;
    if ($headerTop.length) {
        topBarHeight = $headerTop.outerHeight();
    }

    $(window).scroll(function(event){
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(window).scrollTop();

        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        if (st <= topBarHeight) {
            $header.removeClass('nav-down nav-up');
        } else {
            if (st > lastScrollTop && st > navbarHeight) {
                $header.removeClass('nav-down').addClass('nav-up');
            } else {
                if (st + $(window).height() < $(document).height()) {
                    $header.removeClass('nav-up').addClass('nav-down');
                }
            }
        }

        lastScrollTop = st;
    }


});
